module.exports = __webpack_public_path__ + "img/1213546383.42dd5fcf.jpg";